var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1C4.584 1 1 4.584 1 9C1 13.416 4.584 17 9 17C13.416 17 17 13.416 17 9C17 4.584 13.416 1 9 1Z",
    fill: "#1ED760"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5039C9.13807 12.5039 9.25 12.6158 9.25 12.7539C9.25 12.892 9.13807 13.0039 9 13.0039C8.86193 13.0039 8.75 12.892 8.75 12.7539C8.74973 12.6875 8.77599 12.6238 8.82293 12.5768C8.86987 12.5299 8.93362 12.5036 9 12.5039",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.00322C6.99842 5.97878 7.77117 5.11878 8.78995 5.01118C9.80872 4.90359 10.7441 5.5832 10.9565 6.58537C11.169 7.58753 10.5898 8.5882 9.615 8.90322C9.24665 9.02222 8.99782 9.36612 9 9.75322V10.5032",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.ca06c1de.svg";
export { ForwardRef as ReactComponent };